var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pricingscheme", class: { active: _vm.active } },
    [
      _c("div", { staticClass: "pricing-header" }, [
        _c("div", { staticClass: "price" }, [
          _c("span", { staticClass: "currency" }, [
            _vm._v(_vm._s(_vm.pricing.currency))
          ]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.formatPrice(_vm.displayPrice)))])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "interval" }, [
          _vm._v("\n\t\t\t\t" + _vm._s(_vm.interval) + "\n\t\t\t")
        ]),
        _vm._v(" "),
        _vm.waterPeriodPrice && _vm.waterPeriodPrice.period
          ? _c("div", { staticClass: "period-price" }, [
              _vm._v(
                "\n\t\t\t\t" +
                  _vm._s(
                    _vm.$t("pages.dashboard.subscriptions.period_price", {
                      start: _vm.waterPeriodPrice.period.start_date,
                      end: _vm.waterPeriodPrice.period.end_date
                    })
                  ) +
                  "\n\t\t\t"
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "pricing-body" }, [
        _c("div", { staticClass: "ui divider horizontal" }, [
          _vm._v(_vm._s(_vm.$t("components.paymentplan.chosen_product")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "product-block" }, [
          _c("div", { staticClass: "product-price" }, [
            _c("div", { staticClass: "name" }, [
              _vm._v(_vm._s(_vm.subscription.product.name) + ":")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "price" }, [
              _vm._v(
                _vm._s(
                  _vm.getProductPriceFromTotalPrice(
                    _vm.subscription,
                    _vm.pricing
                  )
                ) +
                  " " +
                  _vm._s(_vm.pricing.currency)
              )
            ])
          ]),
          _vm._v(" "),
          _vm.subscription.product.apply_vat
            ? _c("div", { staticClass: "product-vat-price" }, [
                _c("div", { staticClass: "name" }, [_vm._v("25,00% moms:")]),
                _vm._v(" "),
                _c("div", { staticClass: "price" }, [
                  _vm._v(
                    _vm._s(
                      _vm.getProductPriceVatFromTotalPrice(
                        _vm.subscription,
                        _vm.pricing
                      )
                    ) +
                      " " +
                      _vm._s(_vm.pricing.currency)
                  )
                ])
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      (_vm.chosenAccessories && _vm.chosenAccessories.length > 0) ||
      _vm.startUpFee
        ? _c(
            "div",
            { staticClass: "pricing-body" },
            [
              _vm.startUpFee
                ? _c("div", { staticClass: "accessory" }, [
                    _c("div", { staticClass: "name" }, [
                      _vm._v(
                        _vm._s(_vm.$t("components.paymentplan.starting_fee"))
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "price" }, [
                      _vm._v(_vm._s(_vm.startUpFee))
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.chosenAccessories && _vm.chosenAccessories.length
                ? _c("div", { staticClass: "ui divider horizontal" }, [
                    _vm._v(
                      _vm._s(_vm.$t("components.paymentplan.chosen_accessory"))
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.chosenAccessories, function(accessory) {
                return _vm.chosenAccessories && _vm.chosenAccessories.length
                  ? _c(
                      "div",
                      { key: accessory.id, staticClass: "accessory-block" },
                      [
                        _c("div", { staticClass: "accessory-price" }, [
                          _c("div", { staticClass: "name" }, [
                            _vm._v(_vm._s(accessory.name))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "price" }, [
                            _vm._v(
                              _vm._s(_vm.findAccessoryPrice(accessory)) +
                                " " +
                                _vm._s(_vm.pricing.currency)
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        accessory.apply_vat
                          ? _c("div", { staticClass: "accessory-vat-price" }, [
                              _c("div", { staticClass: "name" }, [
                                _vm._v("25,00% moms:")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "price" }, [
                                _vm._v(
                                  _vm._s(_vm.findAccessoryPriceVat(accessory)) +
                                    " " +
                                    _vm._s(_vm.pricing.currency)
                                )
                              ])
                            ])
                          : _vm._e()
                      ]
                    )
                  : _vm._e()
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "pricing-actions" }, [
        !_vm.active
          ? _c(
              "div",
              {
                staticClass: "ui blue circular button",
                on: { click: _vm.selectPaymentplan }
              },
              [_vm._v(_vm._s(_vm.$t("globals.buttons.select")))]
            )
          : _c(
              "div",
              {
                staticClass: "ui blue circular button",
                on: { click: _vm.deselectPaymentplan }
              },
              [_vm._v(_vm._s(_vm.$t("globals.buttons.deselect")))]
            )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-361b5274", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-361b5274","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payment/PaymentPlan.vue
// module id = NlM3
// module chunks = 1